<template>
  <div>
    <div class="listNav">
      <div class="main">
        <span>您的位置：</span>
        <span>首页</span>
        <span>></span>
        <span>资源库</span>
        <span>></span>
        <span>资源库详情</span>
        <span>></span>
        <span>素材列表</span>
        <span>></span>
        <span>素材详情</span>
      </div>
    </div>
    <div class="listcenter">
      <div class="coudetails">
        <div class="coudetailscenter">
          <div>
            <el-row :gutter="28">
              <el-col :span="17">
                <div class="grid-content bg-purple">
                  <div class="courseTit">新突破大学英语综合教程</div>
                  <div class="imgbox">
                    <img src="../../assets/img/courseDet.png" alt />
                  </div>
                </div>
              </el-col>
              <el-col :span="7">
                <div class="grid-content bg-purple couresItem">
                  <div class="resdown">
                    <i class="el-icon-bottom"></i>下载源文件
                  </div>
                  <div class="star">
                    <i class="el-icon-star-off"></i>收藏
                  </div>
                  <div class="lookNum">
                    <div>已下载：202</div>
                    <div>已浏览：202</div>
                  </div>
                  <div class="Info">
                    <div>上传人：范冰冰</div>
                    <div>文件大小：438kb</div>
                    <div>上传时间：2012-2020</div>
                    <div>所属专业：护理专业</div>
                    <div>所属教材：计算机</div>
                    <div>所属类型：PPT演示文稿</div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="detMain">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="简介" name="first">
                <div class="catalog">
                  <div class="line"></div>
                  <div class="catalogTit">简介</div>
                </div>
                <div
                  class="catalogText"
                >根据我国中西部地区高职高专学校教学实际，《新突破大学英语综合教程》由全国教指委英语组成员李力教授担任总主编，由具有丰富大学外语一线教学经验的多名教师分工编撰而成。这门课程充分体现了教育部即将出台的《大学外语教学指南》中的建设多层次多元化目标教学体系，满足学生个性化、多样性学习的要求。</div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: 'first'
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
    }
  }
}
</script>
<style lang="scss" scoped>
.listcenter {
  background: url('../../assets/img/subbg.jpg');
}
.listNav {
  width: 100%;
  height: 42px;
  background: rgba(237, 234, 231, 1);
  span {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    line-height: 42px;
    margin-right: 5px;
  }
  :nth-child(10) {
    color: #b50e05;
  }
}
.coudetails {
  width: 1112px;
  margin: 0 auto;
  height: 100%;
  background-color: #fff;
  .coudetailscenter {
    margin: 0 58px;
    .imgbox {
      width: 100%;
      height: 396px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.courseTit {
  font-size: 24px;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  margin: 20px 0;
}
.couresItem {
  height: 430px;
  padding-left: 30px;
  border-left: 1px solid #e6e6e6;
  .resdown {
    width: 100%;
    height: 50px;
    background: rgba(181, 14, 5, 1);
    color: #fff;
    font-size: 16px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    line-height: 50px;
    margin: 32px 0 20px;
  }
  .star {
    width: 100%;
    height: 40px;
    border: 1px solid rgba(224, 224, 224, 1);
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    text-align: center;
    line-height: 50px;
    margin-top: 10px;
  }
  .lookNum {
    overflow: hidden;
    margin: 15px 0 20px;
    font-size: 14px;
    height: 30px;
    border-bottom: 1px solid #e6e6e6;
    color: rgba(102, 102, 102, 1);
    :nth-child(1) {
      float: left;
    }
    :nth-child(2) {
      float: right;
    }
  }
  .Info {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    line-height: 36px;
  }
}

.catalog {
  overflow: hidden;
  margin: 20px 0;
  .line {
    width: 3px;
    height: 14px;
    background: rgba(181, 14, 5, 1);
    float: left;
  }
  .catalogTit {
    font-size: 14px;
    font-weight: 500;
    color: rgba(181, 14, 5, 1);
    margin-left: 8px;
  }
}
.catalogText {
  margin-top: 20px;
  font-size: 13px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 24px;
  margin-bottom: 50px;
}
.contents {
  overflow: hidden;
  .contentsTit {
    margin-bottom: 20px;
    float: left;
    font-size: 14px;
    font-family: SourceHanSansCN;
    font-weight: 500;
    color: rgba(102, 102, 102, 1);
  }
  .btn {
    float: right;
    width: 82px;
    height: 30px;
    border: 1px solid rgba(224, 224, 224, 1);
    color: rgba(102, 102, 102, 1);
    background-color: none;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    &:hover {
      color: rgba(181, 14, 5, 1);
    }
  }
}
.contentsInfo {
  div {
    font-size: 13px;
    color: rgba(102, 102, 102, 1);
    line-height: 35px;
  }
}
.detMain {
  margin-top: 30px;
}
</style>